import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const VariantList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.Variant} />
        </>
    );
}

export default VariantList;